import { createReducer } from 'redux-create-reducer';
import callAPI from '../../../utils/callAPI';

export const REQUEST_CREATE_TREASURE = 'REQUEST_CREATE_TREASURE';
export const REQUEST_CREATE_TREASURE_SUCCESS = 'REQUEST_CREATE_TREASURE_SUCCESS';
export const REQUEST_CREATE_TREASURE_FAILURE = 'REQUEST_CREATE_TREASURE_FAILURE';

export const REQUEST_FETCH_TREASURE = 'REQUEST_FETCH_TREASURE';
export const REQUEST_FETCH_TREASURE_SUCCESS = 'REQUEST_FETCH_TREASURE_SUCCESS';
export const REQUEST_FETCH_TREASURE_FAILURE = 'REQUEST_FETCH_TREASURE_FAILURE';

export const REQUEST_UPDATE_TREASURE = 'REQUEST_UPDATE_TREASURE';
export const REQUEST_UPDATE_TREASURE_SUCCESS = 'REQUEST_UPDATE_TREASURE_SUCCESS';
export const REQUEST_UPDATE_TREASURE_FAILURE = 'REQUEST_UPDATE_TREASURE_FAILURE';

export const ACTION_REQUEST_UPDATE_TREASURE_DISPLAY = 'ACTION_REQUEST_UPDATE_TREASURE_DISPLAY';
export const ACTION_REQUEST_UPDATE_TREASURE_LOCATION = 'ACTION_REQUEST_UPDATE_TREASURE_LOCATION';
export const ACTION_REQUEST_UPDATE_TREASURE_PRIZE = 'ACTION_REQUEST_UPDATE_TREASURE_PRIZE';
export const ACTION_REQUEST_UPDATE_TREASURE_PRIZE_TYPE =
  'ACTION_REQUEST_UPDATE_TREASURE_PRIZE_TYPE';
export const ACTION_REQUEST_UPDATE_TREASURE_AVAILABILITY =
  'ACTION_REQUEST_UPDATE_TREASURE_AVAILABILITY';
export const ACTION_REQUEST_UPDATE_TREASURE_SUBMIT = 'ACTION_REQUEST_UPDATE_TREASURE_SUBMIT';

// Local state update actions (no API calls)
export const ACTION_UPDATE_LOCAL_TREASURE_DISPLAY = 'ACTION_UPDATE_LOCAL_TREASURE_DISPLAY';
export const ACTION_UPDATE_LOCAL_TREASURE_LOCATION = 'ACTION_UPDATE_LOCAL_TREASURE_LOCATION';
export const ACTION_UPDATE_LOCAL_TREASURE_PRIZE = 'ACTION_UPDATE_LOCAL_TREASURE_PRIZE';
export const ACTION_UPDATE_LOCAL_TREASURE_PRIZE_TYPE = 'ACTION_UPDATE_LOCAL_TREASURE_PRIZE_TYPE';
export const ACTION_UPDATE_LOCAL_TREASURE_AVAILABILITY =
  'ACTION_UPDATE_LOCAL_TREASURE_AVAILABILITY';
export const ACTION_RESET_LOCAL_TREASURE = 'ACTION_RESET_LOCAL_TREASURE';
export const ACTION_REQUEST_FETCH_AR_TEMPLATES = 'ACTION_REQUEST_FETCH_AR_TEMPLATES';

export const REQUEST_FETCH_LIST_COUNTRY = 'REQUEST_FETCH_LIST_COUNTRY';
export const REQUEST_FETCH_LIST_COUNTRY_SUCCESS = 'REQUEST_FETCH_LIST_COUNTRY_SUCCESS';
export const REQUEST_FETCH_LIST_COUNTRY_FAILURE = 'REQUEST_FETCH_LIST_COUNTRY_FAILURE';

export const REQUEST_FETCH_LIST_WINNERS = 'REQUEST_FETCH_LIST_WINNERS';
export const REQUEST_FETCH_LIST_WINNERS_SUCCESS = 'REQUEST_FETCH_LIST_WINNERS_SUCCESS';
export const REQUEST_FETCH_LIST_WINNERS_FAILURE = 'REQUEST_FETCH_LIST_WINNERS_FAILURE';

export const REQUEST_EDIT_WINNERS = 'REQUEST_EDIT_WINNERS';
export const REQUEST_EDIT_WINNERS_SUCCESS = 'REQUEST_EDIT_WINNERS_SUCCESS';
export const REQUEST_EDIT_WINNERS_FAILURE = 'REQUEST_EDIT_WINNERS_FAILURE';

export const REQUEST_FETCH_TREASURE_BY_ID = 'REQUEST_FETCH_TREASURE_BY_ID';
export const REQUEST_FETCH_TREASURE_BY_ID_SUCCESS = 'REQUEST_FETCH_TREASURE_BY_ID_SUCCESS';
export const REQUEST_FETCH_TREASURE_BY_ID_FAILURE = 'REQUEST_FETCH_TREASURE_BY_ID_FAILURE';

export const REQUEST_EDIT_TREASURE = 'REQUEST_EDIT_TREASURE';
export const REQUEST_EDIT_TREASURE_SUCCESS = 'REQUEST_EDIT_TREASURE_SUCCESS';
export const REQUEST_EDIT_TREASURE_FAILURE = 'REQUEST_EDIT_TREASURE_FAILURE';

export const REQUEST_FETCH_AR_TEMPLATES = 'REQUEST_FETCH_AR_TEMPLATES';
export const REQUEST_FETCH_AR_TEMPLATES_SUCCESS = 'REQUEST_FETCH_AR_TEMPLATES_SUCCESS';
export const REQUEST_FETCH_AR_TEMPLATES_FAILURE = 'REQUEST_FETCH_AR_TEMPLATES_FAILURE';

export const REQUEST_GENERATE_3D_MODEL = 'REQUEST_GENERATE_3D_MODEL';
export const REQUEST_GENERATE_3D_MODEL_SUCCESS = 'REQUEST_GENERATE_3D_MODEL_SUCCESS';
export const REQUEST_GENERATE_3D_MODEL_FAILURE = 'REQUEST_GENERATE_3D_MODEL_FAILURE';
export const ACTION_REQUEST_GENERATE_3D_MODEL = 'ACTION_REQUEST_GENERATE_3D_MODEL';

export const REQUEST_CONVERT_GLB_TO_USDZ = 'REQUEST_CONVERT_GLB_TO_USDZ';
export const REQUEST_CONVERT_GLB_TO_USDZ_SUCCESS = 'REQUEST_CONVERT_GLB_TO_USDZ_SUCCESS';
export const REQUEST_CONVERT_GLB_TO_USDZ_FAILURE = 'REQUEST_CONVERT_GLB_TO_USDZ_FAILURE';
export const ACTION_REQUEST_CONVERT_GLB_TO_USDZ = 'ACTION_REQUEST_CONVERT_GLB_TO_USDZ';
export const ACTION_RESET_CONVERTED_USDZ_URL = 'ACTION_RESET_CONVERTED_USDZ_URL';

const defaultState = {
  treasureSteps: [],
  treasure: {},
  localTreasureData: {}, // Local data being built across steps before final submit
  createTreasureLoading: false,
  createTreasureFailed: false,
  fetchTreasureLoading: false,
  fetchTreasureFailed: false,
  updateTreasureLoading: false,
  updateTreasureFailed: false,
  updateTreasureSuccess: false,
  countries: [],
  fetchListCountryLoading: false,
  fetchListCountryFailed: false,
  winners: [],
  fetchListWinnersLoading: false,
  fetchListWinnersFailed: false,
  winnerDetail: {},
  editWinnersLoading: false,
  editWinnersFailed: false,
  treasureById: {}, // this is for the treasure detail page
  arTemplates: [],
  fetchArTemplatesLoading: false,
  fetchArTemplatesFailed: false,
  generate3DModelLoading: false,
  generate3DModelFailed: false,
  generated3DModel: null, // { glb, usdz, obj }
  convertGlbToUsdzLoading: false,
  convertGlbToUsdzFailed: false,
  convertedUsdzUrl: null,
};

const reducer = createReducer(defaultState, {
  [REQUEST_CREATE_TREASURE]: (state, _action) => ({
    ...state,
    createTreasureLoading: true,
    createTreasureFailed: false,
  }),
  [REQUEST_CREATE_TREASURE_SUCCESS]: (state, action) => ({
    ...state,
    treasure: action.payload?.data,
    createTreasureLoading: false,
    createTreasureFailed: false,
  }),
  [REQUEST_CREATE_TREASURE_FAILURE]: (state, _action) => ({
    ...state,
    createTreasureLoading: false,
    createTreasureFailed: true,
  }),
  [REQUEST_FETCH_TREASURE]: (state, _action) => ({
    ...state,
    fetchTreasureLoading: true,
    fetchTreasureFailed: false,
  }),
  [REQUEST_FETCH_TREASURE_SUCCESS]: (state, action) => ({
    ...state,
    treasure: action.payload?.data,
    fetchTreasureLoading: false,
    fetchTreasureFailed: false,
  }),
  [REQUEST_FETCH_TREASURE_FAILURE]: (state, _action) => ({
    ...state,
    fetchTreasureLoading: false,
    fetchTreasureFailed: true,
  }),
  [REQUEST_UPDATE_TREASURE]: (state, _action) => ({
    ...state,
    updateTreasureLoading: true,
    updateTreasureFailed: false,
  }),
  [REQUEST_UPDATE_TREASURE_SUCCESS]: (state, action) => ({
    ...state,
    treasure: { ...state?.treasure, ...action.payload?.data },
    updateTreasureLoading: false,
    updateTreasureFailed: false,
  }),
  [REQUEST_UPDATE_TREASURE_FAILURE]: (state, _action) => ({
    ...state,
    updateTreasureLoading: false,
    updateTreasureFailed: true,
  }),
  [REQUEST_FETCH_LIST_COUNTRY]: (state, _action) => ({
    ...state,
    fetchListCountryLoading: true,
    fetchListCountryFailed: false,
  }),
  [REQUEST_FETCH_LIST_COUNTRY_SUCCESS]: (state, action) => ({
    ...state,
    countries: [{ id: '', iso: '', name: 'All Country' }, ...(action.payload?.data?.items || [])],
    fetchListCountryLoading: false,
    fetchListCountryFailed: false,
  }),
  [REQUEST_FETCH_LIST_COUNTRY_FAILURE]: (state, _action) => ({
    ...state,
    fetchListCountryLoading: false,
    fetchListCountryFailed: true,
  }),
  [REQUEST_FETCH_LIST_WINNERS]: (state, _action) => ({
    ...state,
    fetchListWinnersLoading: true,
    fetchListWinnersFailed: false,
  }),
  [REQUEST_FETCH_LIST_WINNERS_SUCCESS]: (state, action) => {
    return {
      ...state,
      winners: action.payload?.data || [],
      fetchListWinnersLoading: false,
      fetchListWinnersFailed: false,
    };
  },
  [REQUEST_FETCH_LIST_WINNERS_FAILURE]: (state, _action) => ({
    ...state,
    fetchListWinnersLoading: false,
    fetchListWinnersFailed: true,
  }),

  [REQUEST_EDIT_WINNERS]: (state, _action) => ({
    ...state,
    editWinnersLoading: true,
    editWinnersFailed: false,
  }),
  [REQUEST_EDIT_WINNERS_SUCCESS]: (state, action) => {
    return {
      ...state,
      winnerDetail: action.payload?.data || {},
      editWinnersLoading: false,
      editWinnersFailed: false,
    };
  },
  [REQUEST_EDIT_WINNERS_FAILURE]: (state, _action) => ({
    ...state,
    editWinnersLoading: false,
    editWinnersFailed: true,
  }),

  [REQUEST_FETCH_TREASURE_BY_ID]: (state, _action) => ({
    ...state,
    fetchTreasureLoading: true,
    fetchTreasureFailed: false,
  }),
  [REQUEST_FETCH_TREASURE_BY_ID_SUCCESS]: (state, action) => ({
    ...state,
    treasureById: action.payload?.data,
    fetchTreasureLoading: false,
    fetchTreasureFailed: false,
  }),
  [REQUEST_FETCH_TREASURE_BY_ID_FAILURE]: (state, _action) => ({
    ...state,
    fetchTreasureLoading: false,
    fetchTreasureFailed: true,
  }),

  [REQUEST_EDIT_TREASURE]: (state, _action) => {
    return {
      ...state,
      updateTreasureLoading: true,
      updateTreasureFailed: false,
    };
  },
  [REQUEST_EDIT_TREASURE_SUCCESS]: (state, _action) => {
    return {
      ...state,
      updateTreasureLoading: false,
      updateTreasureFailed: false,
      updateTreasureSuccess: true,
    };
  },
  [REQUEST_EDIT_TREASURE_FAILURE]: (state, _action) => {
    return {
      ...state,
      updateTreasureLoading: false,
      updateTreasureFailed: true,
    };
  },

  // Local state update reducers
  [ACTION_UPDATE_LOCAL_TREASURE_DISPLAY]: (state, action) => ({
    ...state,
    localTreasureData: {
      ...state.localTreasureData,
      treasureDisplay: action.payload,
    },
  }),
  [ACTION_UPDATE_LOCAL_TREASURE_LOCATION]: (state, action) => ({
    ...state,
    localTreasureData: {
      ...state.localTreasureData,
      treasureLocation: action.payload,
    },
  }),
  [ACTION_UPDATE_LOCAL_TREASURE_PRIZE]: (state, action) => ({
    ...state,
    localTreasureData: {
      ...state.localTreasureData,
      treasurePrize: action.payload,
    },
  }),
  [ACTION_UPDATE_LOCAL_TREASURE_PRIZE_TYPE]: (state, action) => ({
    ...state,
    localTreasureData: {
      ...state.localTreasureData,
      treasurePrizeType: action.payload,
    },
  }),
  [ACTION_UPDATE_LOCAL_TREASURE_AVAILABILITY]: (state, action) => ({
    ...state,
    localTreasureData: {
      ...state.localTreasureData,
      treasureAvailability: action.payload,
    },
  }),
  [ACTION_RESET_LOCAL_TREASURE]: (state, _action) => ({
    ...state,
    localTreasureData: {},
    treasure: {},
    fetchTreasureFailed: false,
    fetchTreasureLoading: false,
    generated3DModel: null,
    convertedUsdzUrl: null,
  }),

  [REQUEST_FETCH_AR_TEMPLATES]: (state, _action) => ({
    ...state,
    fetchArTemplatesLoading: true,
    fetchArTemplatesFailed: false,
  }),
  [REQUEST_FETCH_AR_TEMPLATES_SUCCESS]: (state, action) => {
    // Only use 'others' items from response, exclude 'default'
    // callAPI returns data in action.payload.data
    const templates = action.payload?.data?.others?.items || [];
    return {
      ...state,
      arTemplates: templates,
      fetchArTemplatesLoading: false,
      fetchArTemplatesFailed: false,
    };
  },
  [REQUEST_FETCH_AR_TEMPLATES_FAILURE]: (state, _action) => ({
    ...state,
    fetchArTemplatesLoading: false,
    fetchArTemplatesFailed: true,
  }),
  [REQUEST_GENERATE_3D_MODEL]: (state, _action) => ({
    ...state,
    generate3DModelLoading: true,
    generate3DModelFailed: false,
  }),
  [REQUEST_GENERATE_3D_MODEL_SUCCESS]: (state, action) => ({
    ...state,
    generate3DModelLoading: false,
    generate3DModelFailed: false,
    generated3DModel: action.payload?.data || null,
  }),
  [REQUEST_GENERATE_3D_MODEL_FAILURE]: (state, _action) => ({
    ...state,
    generate3DModelLoading: false,
    generate3DModelFailed: true,
  }),
  [REQUEST_CONVERT_GLB_TO_USDZ]: (state, _action) => ({
    ...state,
    convertGlbToUsdzLoading: true,
    convertGlbToUsdzFailed: false,
  }),
  [REQUEST_CONVERT_GLB_TO_USDZ_SUCCESS]: (state, action) => ({
    ...state,
    convertGlbToUsdzLoading: false,
    convertGlbToUsdzFailed: false,
    convertedUsdzUrl: action.payload?.data?.usdzUrl || action.payload?.usdzUrl || null,
  }),
  [REQUEST_CONVERT_GLB_TO_USDZ_FAILURE]: (state, _action) => ({
    ...state,
    convertGlbToUsdzLoading: false,
    convertGlbToUsdzFailed: true,
  }),
  [ACTION_RESET_CONVERTED_USDZ_URL]: (state, _action) => ({
    ...state,
    convertedUsdzUrl: null,
  }),
});

export default reducer;
export const namespace = 'placeArTreasure';

export const createTreasure = () => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/campaigns/treasures',
    actionTypes: [
      REQUEST_CREATE_TREASURE,
      REQUEST_CREATE_TREASURE_SUCCESS,
      REQUEST_CREATE_TREASURE_FAILURE,
    ],
    variables: {},
    dispatch,
    getState,
  });
};

export const fetchTreasureById = (treasureId) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: `/campaigns/treasures/${treasureId}`,
    actionTypes: [
      REQUEST_FETCH_TREASURE,
      REQUEST_FETCH_TREASURE_SUCCESS,
      REQUEST_FETCH_TREASURE_FAILURE,
    ],
    variables: {},
    dispatch,
    getState,
  });
};

export const fetchListCountry = () => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: `/countries`,
    actionTypes: [
      REQUEST_FETCH_LIST_COUNTRY,
      REQUEST_FETCH_LIST_COUNTRY_SUCCESS,
      REQUEST_FETCH_LIST_COUNTRY_FAILURE,
    ],
    variables: {},
    dispatch,
    getState,
  });
};

export const updateTreasureDisplay = (payload) => ({
  type: ACTION_REQUEST_UPDATE_TREASURE_DISPLAY,
  payload: payload,
});

export const updateTreasureLocation = (payload) => ({
  type: ACTION_REQUEST_UPDATE_TREASURE_LOCATION,
  payload: payload,
});

export const updateTreasurePrize = (payload) => ({
  type: ACTION_REQUEST_UPDATE_TREASURE_PRIZE,
  payload: payload,
});

export const updateTreasurePrizeType = (payload) => ({
  type: ACTION_REQUEST_UPDATE_TREASURE_PRIZE_TYPE,
  payload: payload,
});

export const updateTreasureAvailability = (payload) => ({
  type: ACTION_REQUEST_UPDATE_TREASURE_AVAILABILITY,
  payload: payload,
});

export const updateTreasureSubmit = (payload) => ({
  type: ACTION_REQUEST_UPDATE_TREASURE_SUBMIT,
  payload: payload,
});

export const updateTreasureDisplayAPI = (payload) => async (dispatch, getState) => {
  return await callAPI({
    method: 'put',
    apiPath: `campaigns/treasures/${payload?.treasureId}/display`,
    actionTypes: [
      REQUEST_UPDATE_TREASURE,
      REQUEST_UPDATE_TREASURE_SUCCESS,
      REQUEST_UPDATE_TREASURE_FAILURE,
    ],
    variables: { ...payload, treasureId: undefined },
    dispatch,
    getState,
  });
};

export const updateTreasureLocationAPI = (payload) => async (dispatch, getState) => {
  return await callAPI({
    method: 'put',
    apiPath: `campaigns/treasures/${payload?.treasureId}/location`,
    actionTypes: [
      REQUEST_UPDATE_TREASURE,
      REQUEST_UPDATE_TREASURE_SUCCESS,
      REQUEST_UPDATE_TREASURE_FAILURE,
    ],
    variables: { ...payload, treasureId: undefined },
    dispatch,
    getState,
  });
};

export const updateTreasurePrizeAPI = (payload) => async (dispatch, getState) => {
  return await callAPI({
    method: 'put',
    apiPath: `campaigns/treasures/${payload?.treasureId}/prize`,
    actionTypes: [
      REQUEST_UPDATE_TREASURE,
      REQUEST_UPDATE_TREASURE_SUCCESS,
      REQUEST_UPDATE_TREASURE_FAILURE,
    ],
    variables: { ...payload, treasureId: undefined },
    dispatch,
    getState,
  });
};

export const updateTreasurePrizeTypeAPI = (payload) => async (dispatch, getState) => {
  return await callAPI({
    method: 'put',
    apiPath: `campaigns/treasures/${payload?.treasureId}/prize-type`,
    actionTypes: [
      REQUEST_UPDATE_TREASURE,
      REQUEST_UPDATE_TREASURE_SUCCESS,
      REQUEST_UPDATE_TREASURE_FAILURE,
    ],
    variables: { ...payload, treasureId: undefined },
    dispatch,
    getState,
  });
};

export const updateTreasureAvailabilityAPI = (payload) => async (dispatch, getState) => {
  return await callAPI({
    method: 'put',
    apiPath: `campaigns/treasures/${payload?.treasureId}/availability`,
    actionTypes: [
      REQUEST_UPDATE_TREASURE,
      REQUEST_UPDATE_TREASURE_SUCCESS,
      REQUEST_UPDATE_TREASURE_FAILURE,
    ],
    variables: { ...payload, treasureId: undefined },
    dispatch,
    getState,
  });
};

export const updateTreasureSubmitAPI = (payload) => async (dispatch, getState) => {
  return await callAPI({
    method: 'put',
    apiPath: `campaigns/treasures/${payload?.treasureId}/submit`,
    actionTypes: [
      REQUEST_UPDATE_TREASURE,
      REQUEST_UPDATE_TREASURE_SUCCESS,
      REQUEST_UPDATE_TREASURE_FAILURE,
    ],
    variables: { ...payload, treasureId: undefined },
    dispatch,
    getState,
  });
};

export const fetchListWinnersAPI = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: `/campaigns/treasures/winners`,
    actionTypes: [
      REQUEST_FETCH_LIST_WINNERS,
      REQUEST_FETCH_LIST_WINNERS_SUCCESS,
      REQUEST_FETCH_LIST_WINNERS_FAILURE,
    ],
    variables: { ...filter },
    dispatch,
    getState,
  });
};

export const editTreasureAPI =
  ({ treasureId, payload }) =>
  async (dispatch, getState) => {
    return await callAPI({
      method: 'put',
      apiPath: `/campaigns/treasures/placed/${treasureId}`,
      actionTypes: [
        REQUEST_EDIT_TREASURE,
        REQUEST_EDIT_TREASURE_SUCCESS,
        REQUEST_EDIT_TREASURE_FAILURE,
      ],
      variables: payload,
      dispatch,
      getState,
    });
  };

export const fetchTreasureByIdAPI = (treasureId) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: `/campaigns/treasures/${treasureId}`,
    actionTypes: [
      REQUEST_FETCH_TREASURE_BY_ID,
      REQUEST_FETCH_TREASURE_BY_ID_SUCCESS,
      REQUEST_FETCH_TREASURE_BY_ID_FAILURE,
    ],
    variables: {},
    dispatch,
    getState,
  });
};

export const submitTreasureAPI = (payload) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: `/campaigns/treasures/place`,
    actionTypes: [
      REQUEST_UPDATE_TREASURE,
      REQUEST_UPDATE_TREASURE_SUCCESS,
      REQUEST_UPDATE_TREASURE_FAILURE,
    ],
    variables: payload,
    dispatch,
    getState,
  });
};

export const fetchArTemplatesAPI =
  (params = {}) =>
  async (dispatch, getState) => {
    return await callAPI({
      method: 'get',
      apiPath: '/ar-template',
      actionTypes: [
        REQUEST_FETCH_AR_TEMPLATES,
        REQUEST_FETCH_AR_TEMPLATES_SUCCESS,
        REQUEST_FETCH_AR_TEMPLATES_FAILURE,
      ],
      variables: {
        page: params.page || 1,
        limit: params.limit || 10,
        type: params.type || 'clue',
      },
      dispatch,
      getState,
    });
  };

export const generate3DModelAPI = (params) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/3d-model/generate',
    actionTypes: [
      REQUEST_GENERATE_3D_MODEL,
      REQUEST_GENERATE_3D_MODEL_SUCCESS,
      REQUEST_GENERATE_3D_MODEL_FAILURE,
    ],
    variables: params,
    dispatch,
    getState,
  });
};

export const convertGlbToUsdzAPI = (params) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/3d-model/convert-glb-to-usdz',
    actionTypes: [
      REQUEST_CONVERT_GLB_TO_USDZ,
      REQUEST_CONVERT_GLB_TO_USDZ_SUCCESS,
      REQUEST_CONVERT_GLB_TO_USDZ_FAILURE,
    ],
    variables: params,
    dispatch,
    getState,
  });
};

export const fetchWinnerDetailByIdAPI = (winnerId, filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: `/campaigns/treasures/winners/${winnerId}`,
    actionTypes: [REQUEST_EDIT_WINNERS, REQUEST_EDIT_WINNERS_SUCCESS, REQUEST_EDIT_WINNERS_FAILURE],
    variables: { ...filter },
    dispatch,
    getState,
  });
};

// Local state update action creators (no API calls)
export const updateLocalTreasureDisplay = (payload) => ({
  type: ACTION_UPDATE_LOCAL_TREASURE_DISPLAY,
  payload: payload,
});

export const updateLocalTreasureLocation = (payload) => ({
  type: ACTION_UPDATE_LOCAL_TREASURE_LOCATION,
  payload: payload,
});

export const updateLocalTreasurePrize = (payload) => ({
  type: ACTION_UPDATE_LOCAL_TREASURE_PRIZE,
  payload: payload,
});

export const updateLocalTreasurePrizeType = (payload) => ({
  type: ACTION_UPDATE_LOCAL_TREASURE_PRIZE_TYPE,
  payload: payload,
});

export const updateLocalTreasureAvailability = (payload) => ({
  type: ACTION_UPDATE_LOCAL_TREASURE_AVAILABILITY,
  payload: payload,
});

export const resetLocalTreasure = () => ({
  type: ACTION_RESET_LOCAL_TREASURE,
});

export const requestFetchArTemplates = (params = {}) => ({
  type: ACTION_REQUEST_FETCH_AR_TEMPLATES,
  payload: {
    page: params.page || 1,
    limit: params.limit || 10,
    type: params.type || 'clue',
  },
});

export const requestGenerate3DModel = (params) => ({
  type: ACTION_REQUEST_GENERATE_3D_MODEL,
  payload: params,
});

export const requestConvertGlbToUsdz = (params) => ({
  type: ACTION_REQUEST_CONVERT_GLB_TO_USDZ,
  payload: params,
});

export const resetConvertedUsdzUrl = () => ({
  type: ACTION_RESET_CONVERTED_USDZ_URL,
});
